import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import BackButton from '../custom/BackButton';
import { IUser } from '../../globals/interfaces';
import { properCaps } from '../../utils';
import _ from 'lodash';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    user: IUser;
}

export default function ModalSignature({
    modal,
    setModal,
    user
}: Props) {

    const [copied, setCopied] = useState(false);
    const lowerCaseEmail = _.get(user, 's_email', '').toLowerCase();
    const toggle = () => setModal(!modal);

    const signatureHtml = `
    <div>
      <p>Sincerely,</p>
      <p style="margin-bottom: 0px;">
        <strong>${properCaps(user.displayName)}</strong> ${properCaps(`| ${user.s_department} | ${user.s_job_title}`)}
      </p>
      <table>
        <tr>
          <td>
            <img src="https://ewrstorage1.blob.core.windows.net/pics/choice-logo-small.png" style="vertical-align: middle;" />
          </td>
          <td style="padding-left: 50px;">
            <p style="margin-bottom: 0px;">|:. Phone: +1 ${user.s_station_phone}</p>
            <p style="margin-bottom: 0px;">|:. Email: <a href="mailto:${lowerCaseEmail}" style="color: #0000EE; text-decoration: none;">${lowerCaseEmail}</a></p>
            <p style="margin-bottom: 0px;">|:. Web: <a href="https://choice.aero" style="color: #0000EE; text-decoration: none;">https://choice.aero</a></p>
          </td>
        </tr>
      </table>
    </div>
  `;

    const copyHtmlToClipboard = (htmlString: any) => {
        navigator.clipboard.write([
            new ClipboardItem({
                'text/html': new Blob([htmlString], { type: 'text/html' }),
                'text/plain': new Blob([htmlString], { type: 'text/plain' })
            })
        ]).then(() => {
            setCopied(true); // Update state to show feedback
        }).catch(err => {
            console.error('Failed to copy:', err);
        });
    };


    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>My Signature</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <div dangerouslySetInnerHTML={{ __html: signatureHtml }} />
                {/* CopyToClipboard button */}
                <button onClick={() => copyHtmlToClipboard(signatureHtml)}>Copy Signature</button>

                {/* Feedback to the user */}
                {copied ? <span style={{ color: 'green' }}>Copied!</span> : null}
            </ModalBody>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;